import FingerprintJS from '@fingerprintjs/fingerprintjs';
import state from '@ugc-store';

export async function getVisitorId() {
  try {
    if (!state.visitorId) {
      const fpPromise = await FingerprintJS.load();
      const result = await fpPromise.get();
      state.visitorId = result.visitorId;
    }
  } catch (e) {
    return '';
  }
}
